import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppProvider }  from './context/AppContext';

import Login          from './pages/Login';
import Register       from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard      from './pages/Dashboard';
import Farmers        from './pages/Farmers';
import RateChart      from './pages/RateChart';
import Collections    from './pages/Collections';
import AutomaticCollection from './pages/AutomaticCollection';
import SmsLogs        from './pages/SmsLogs';
import Foods          from './pages/Foods';
import CenterInfo     from './pages/CenterInfo';
import Advance        from './pages/Advance';
import Deduction      from './pages/Deduction';
import Invoice        from './pages/Invoice';
import MilkSale           from './pages/MilkSale';
import MilkSaleRateChart   from './pages/MilkSaleRateChart';
import MilkSaleInvoice    from './pages/MilkSaleInvoice';
import AnnualBonus    from './pages/AnnualBonus';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function DashboardLanding() {
  const { user } = useAuth();
  return String(user?.roleCode || '').toUpperCase() === 'SUPERADMIN'
    ? <Navigate to="/admin" replace />
    : <Dashboard />;
}

function App() {
  return (
    <AuthProvider>
      <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"                element={<Navigate to="/login" />} />
          <Route path="/login"           element={<Login />} />
          <Route path="/register"        element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard"         element={<DashboardLanding />} />
            <Route path="/admin"             element={<AdminDashboard />} />
            <Route path="/farmers"           element={<Farmers />} />
            <Route path="/rate-chart"        element={<RateChart />} />
            <Route path="/annual-bonus"      element={<AnnualBonus />} />
            <Route path="/collections"       element={<Collections />} />
            <Route path="/automatic-collection" element={<AutomaticCollection />} />
            <Route path="/sms-logs"          element={<SmsLogs />} />
            <Route path="/foods"             element={<Foods />} />
            <Route path="/center-info"       element={<CenterInfo />} />
            <Route path="/advance"           element={<Advance />} />
            <Route path="/deduction"         element={<Deduction />} />
            <Route path="/invoices"          element={<Invoice />} />
            <Route path="/milk-sale"         element={<MilkSale />} />
            <Route path="/customers"         element={<MilkSale />} />
            <Route path="/milk-rate-chart"   element={<MilkSaleRateChart />} />
            <Route path="/milk-sale-invoice" element={<MilkSaleInvoice />} />
          </Route>
          <Route path="*"                element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
    </AuthProvider>
  );
}

export default App;
